import { AppPasswordField } from '@core/authentication/models/app-password.field';

export const PASSWORD_REPEAT_FIELDS = {
  password: new AppPasswordField({}),
  passwordRepeat: new AppPasswordField({}),
};
